<div class="rule-dialog">
  <div class="dialog-header">
    <span>Terms & Conditions</span>
    <cs-icon-button
      class="btn-close"
      iconType="icon"
      icon="fi-x"
      color="secondary"
      size="12"
      (buttonClick)="close()"
    ></cs-icon-button>
  </div>
  <div class="dialog-content">
    <div class="section">
      <div class="title">Available to claim</div>
      <div class="list">
        @for (item of data; track $index) {
          <div class="item">
            <div class="name">{{ item.currency }}</div>
            <div class="amount">
              <span>{{ item.balance | currencyValue: item.currency }}</span>
              <img [src]="item.currency | currencyIcon" alt="" />
            </div>
          </div>
        }
      </div>
    </div>
    <div class="section">
      <div class="title">Cashback Terms (Brief)</div>
      <ul class="terms-list">
        <li>Cashback percentage depends on your <strong>Loyalty Level</strong> (up to <strong>10%</strong>).</li>
        <li>Cashback is <strong>calculated daily at 01:00 UTC</strong>.</li>
        <li>Cashback applies <strong>only when your net result is negative</strong>.</li>
        <li>Only <strong>settled bets</strong> and <strong>completed rounds</strong> count toward cashback calculation.</li>
        <li>Cashback is calculated using the formula: <strong>Bets - Wins - Bonus Cost</strong>.</li>
        <li>Cashback <strong>builds continuously</strong> throughout the calculation period.</li>
        <li><strong>No wagering requirements</strong> apply to received cashback.</li>
        <li>General terms apply</li>
      </ul>
    </div>
  </div>
  <div class="dialog-btn">
    <cs-button class="close-btn" [height]="'48px'" [size]="'large'" [label]="'Close'" (buttonClick)="close()" />
  </div>
</div>
